import { emoji } from './emoji';
import { hardBreak } from './hard-break';
import { mediaInline } from './media-inline';
import { mention } from './mention';
import { text } from './text';
import { inlineCard } from './inline-card';
import { status } from './status';
import { unknown } from './unknown';
import { date } from './date';
var inlinesEncoderMapping = {
  emoji: emoji,
  hardBreak: hardBreak,
  mediaInline: mediaInline,
  mention: mention,
  text: text,
  inlineCard: inlineCard,
  status: status,
  date: date
};
export var inlines = function inlines(node, opts) {
  var encoder = inlinesEncoderMapping[node.type.name];
  if (encoder) {
    return encoder(node, opts);
  }
  return unknown(node);
};